import type { PolygonWithHoles, Vec2 } from '../../geo/types';
import type { DensifyConfig } from '../terrain/densify';
import { heightTiles } from '../terrain/heightTiles';
import { boundaryHeight } from './boundaryHeight';

type Height = number | ((p: Vec2) => number);
interface GroundPlan {
  readonly tiles?: readonly PolygonWithHoles[];
  readonly height: Height;
  readonly config: DensifyConfig | undefined;
}

/** Tile first, then bind the same shared-outline vertex profile to refinement and emission. */
export function groundPlan(
  polygon: PolygonWithHoles,
  height: Height,
  config: DensifyConfig | undefined
): GroundPlan {
  const surface = config?.surface;
  if (typeof height !== 'function' || !surface) return { height, config };
  if (surface.tileSize) {
    const tiles = heightTiles(polygon, surface.tileSize);
    if (tiles.length !== 1 || tiles[0] !== polygon)
      return { tiles, height, config: { ...config, surface: { ...surface, tileSize: 0 } } };
  }
  if (!surface.withVertexHeight) return { height, config };
  const profile = boundaryHeight(polygon, height, config);
  return {
    height: profile,
    config: {
      ...config,
      surface: { ...surface.withVertexHeight(profile), tileSize: surface.tileSize },
    },
  };
}
